import { Color } from '../../color.model';

export const teal: Color = {
  light: {
    0: 'white',
    1: 'hsl(165, 60.0%, 98.8%)',
    2: 'hsl(169, 64.7%, 96.7%)',
    3: 'hsl(169, 59.8%, 94.0%)',
    4: 'hsl(169, 53.1%, 90.2%)',
    5: 'hsl(170, 47.1%, 85.0%)',
    6: 'hsl(170, 42.6%, 77.9%)',
    7: 'hsl(170, 39.9%, 68.1%)',
    8: 'hsl(172, 42.1%, 52.5%)',
    9: 'hsl(173, 80.0%, 36.0%)',
    10: 'hsl(173, 83.4%, 32.5%)',
    11: 'hsl(174, 90.0%, 25.2%)',
    12: 'hsl(170, 50.0%, 12.5%)',
  },
  dark: {
    0: 'white',
    1: 'hsl(168, 48.0%, 6.5%)',
    2: 'hsl(169, 77.8%, 7.1%)',
    3: 'hsl(170, 76.1%, 9.2%)',
    4: 'hsl(171, 75.8%, 11.0%)',
    5: 'hsl(171, 75.7%, 12.8%)',
    6: 'hsl(172, 75.8%, 15.1%)',
    7: 'hsl(172, 76.7%, 18.6%)',
    8: 'hsl(173, 80.2%, 23.7%)',
    9: 'hsl(173, 80.0%, 36.0%)',
    10: 'hsl(174, 83.9%, 38.2%)',
    11: 'hsl(174, 90.0%, 40.7%)',
    12: 'hsl(166, 73.0%, 93.1%)',
  },
};
